import { User, UserOrganization } from '@/common/models';
import { QueryParams } from '@/common/models/query-params';
import OrgAppAPIProxy from '@/org-app/api';
import { queryKeys } from '@/org-app/services/tanstack/queryKeys';
import { createGetAllQuery } from '@/org-app/services/tanstack/queryUtils';
import orgAppStore from '@/org-app/store';
import { UPDATE_USERORGANIZATIONS_LIST } from '@/org-app/store/modules/users/mutation-types';
import LocalCache from '@/utils/LocalCache';

export const useUserOrganizations = createGetAllQuery<UserOrganization>(
  [queryKeys.userOrganizations],
  () => OrgAppAPIProxy.instance.getUserOrganizations({ queryParams: QueryParams.all() }),
  (data) => {
    orgAppStore.modules.Users.mutations[UPDATE_USERORGANIZATIONS_LIST](orgAppStore.modules.Users.state, data);
  },
  (data) => {
    const user = User.fromApi(LocalCache.get('profile'));
    const currentUser = data.find((u) => u.userID === user.id);

    if (!currentUser) {
      const userOrg = new UserOrganization(user.id, null, null, null, user.id, user, null, null);
      return [...data, userOrg];
    }

    return data;
  },
);
